import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";
import Title from "../../components/Title";
import SocialMedia from "../../components/SocialMedia";
import titleline from "../../assets/images/webp/title_line.webp";
import bgnews from "../../assets/images/webp/bg-news.webp";
import ArrowImage from "../../assets/images/webp/view_all_arrow.webp";

import { newsList } from "../../store/news/newsSlice";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination, } from 'swiper/modules';
import moment from 'moment';


function Index() {
  const Header = React.lazy(() => import("../../layout/Header"));
  const Footer = React.lazy(() => import("../../layout/Footer"));

  const dispatch = useDispatch();
  const { data, isLoader } = useSelector((state) => state?.news);

  useEffect(() => {
    dispatch(newsList());
  }, []);

    const daysDifference = (date) => {
    var startDate = moment(date, "DD MMM yyyy");
    var endDate = moment( new Date(), "DD MMM yyyy");
    return endDate.diff(startDate, 'days');  
  }

  return (
    <>
      {isLoader && <Loader />}
      <Suspense fallback={<Loader />}>
        <section className="section-news">
          <Header type="news" />
          <div className="container-fluid p-0 pb-5">
            <div className="news-new-item" style={{ backgroundImage: `url(${bgnews})` }}>
              <div className="container">
                <div className="row news-row ">
                  <div className="col-lg-7 order-2 order-lg-1">
                    <div className="img-border-outside">
                      <div className="img-border-inside">
                        <img
                          src={data.length > 0 && data[0].image}
                          alt="..."
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5 my-auto order-1 order-lg-2">
                    <div className="position-relative">
                      <Title text={data.length > 0 && data[0].title} />
                      <img src={titleline} alt="" width={"100%"} className="mt-0 position-absolute" style={{ left: -30, bottom: 2 }} />
                    </div>
                    <div className="row align-items-center mb-2">
                      <div className="col-md-8 col-8">{data.length > 0 && daysDifference(data[0].date)} Days ago</div>
                      <div className="col-md-4 col-4">
                        <SocialMedia />
                      </div>
                    </div>
                    <p className="card-text mb-1 d-none d-lg-block">
                      {data.length > 0 && data[0].shortDesc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row mt-5">
              <div className="col-lg-12 mb-3 position-relative">
                <Title text="ALL News" />
                <img src={titleline} alt="" width={"18%"} className="position-absolute start-0" />
              </div>
              {/* <div className="col-lg-12 sub-news-section">
                {data?.length > 0 && <Swiper
                  spaceBetween={20}
                  navigation={false}
                  modules={[Pagination]}
                  pagination={{ clickable: true }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1.3,
                    },
                    576: {
                      slidesPerView: 1.3,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    992: {
                      slidesPerView: 3,
                    },
                  }}
                >

                  {data.length > 0 && data?.map((item, index) => (
                    <SwiperSlide key={index}>
                      <Link
                        to={`/news-details/${item?._id}`}
                        className="text-white"
                      >
                        <div className="news-section">
                          <div className="col-item123 news-img-before">
                            <img
                              className="img-fluid news-img"
                              src={item.image}
                              alt={""}
                            // onError={(e) => e.target.src = NoImage}
                            />
                          </div>
                          <div className="news-box-cont pb-0">
                            <h4 className="text-uppercase mb-2">
                              {item.title}
                            </h4>
                            <img
                              src={titleline}
                              alt=""
                              width={"100%"}
                              className="mb-0 mt-0 position-absolute" style={{ left: 0, bottom: 3 }}
                            />
                          </div>
                        </div>
                      </Link>
                    </SwiperSlide>))}

                </Swiper>}
              </div> */}
              {/* {data.length > 0 &&
              data.slice(0, 3).map((item, index) => {
                return (
                  <div className="col-lg-4  d-none d-lg-block"  key={index}>
                    <Link
                      to={`/news-details/${item?._id}`}
                     
                      className="text-white"
                    >
                      <div className="news-section">
                          <div className="col-item123 news-img-before">
                            <img
                              className="img-fluid news-img"
                              src={item.image}
                              alt={""}
                              // onError={(e) => e.target.src = NoImage}
                            />
                          </div>
                          <div className="news-box-cont pb-0">
                            <h4 className="text-uppercase mb-2">
                              {item.title}
                            </h4>
                            <img
                              src={titleline}
                              alt=""
                              width={"100%"}
                            className="mb-0 mt-0 position-absolute" style={{ left: 0, bottom: 3 }}
                            />
                          </div>
                      </div>
                    </Link>
                  </div>
                );
              })} */}
            </div>
            {/* <div className="row mt-4 mb-4">
              <div className="col-lg-12 text-center">
                <img src={titleline} alt="" width={"100%"} />
              </div>
            </div> */}
            {data.length > 0 &&
              data.map((item, index) => {
                return (
                  <div className="row pb-5" key={index}>
                    <div className="col-lg-4 col-md-12">
                      <div className="news-section">
                        <div className="news-img-before">
                          <Link
                            to={`/news-details/${item?._id}`}
                            key={index}
                          className="text-decoration-none"
                          >
                            <img src={item.image} className="img-fluid" alt="..." />
                            </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="card-body">
                        <h6 className="card-title line-height-6 d-none d-lg-block">
                          <div>{item.date}</div>
                          <img src={titleline} alt="" width={"13%"} />
                        </h6>
                        <div className="mt-2 mb-2 mt-lg-0 position-relative">  <Link
                            to={`/news-details/${item?._id}`}
                            key={index}
                          className="text-decoration-none"
                          style={{color :"#e0d9d9"}}
                          >
                          <Title text={item.title} />
                          <img
                            src={titleline}
                            alt=""
                            width={"75%"}
                            className="mt-0 position-absolute start-0"
                            style={{ bottom: 6 }}
                          />
                          </Link>
                        </div>

                        <p className="card-text mb-1">{item.shortDesc}</p>
                        <div className="d-flex justify-content-between">
                          <Link
                            to={`/news-details/${item?._id}`}
                            key={index}
                            className="text-white text-decoration-none"
                          >
                            <div className="see-article d-flex align-items-center">See Article
                             <img src={ArrowImage} className=" ms-2" alt="" width={7}  />
                            </div>
                          </Link>
                          <div className="d-block d-lg-none">{item.date}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </section>
        <Footer />
      </Suspense>
    </>
  );
}

export default Index;
